export default {
  reservations: 'Reservations',
  activated: 'Activated',
  deactivated: 'Deactivated',
  reservations_deactivated: 'Reservations are deactivated.',
  tabs: {
    general: 'General',
    information: 'Information',
  },
  sections: {
    notifications_confirmation: 'Notifications & Confirmation',
    notifications_confirmation_description: 'How guests book and how you get notified.',
    who_can_book: 'Who can book',
    who_can_book_description: 'Party size limits for online reservations.',
    when_how_bookings_work: 'When & how bookings work',
    when_how_bookings_work_description: 'Timing, duration and capacity rules that decide which slots guests see.',
  },
  google: {
    label: 'Display Reservations on Google',
  },
  storefront: {
    label: 'Display Reservations on Storefront',
  },
  auto_confirm: {
    label: 'Automatically Confirm Reservations',
  },
  email: {
    label: 'Email for Incoming Reservations',
    add: 'Add Email',
    placeholder: 'Enter email',
    required: 'Add at least one email to receive new reservations.',
    invalid: 'Enter a valid email address.',
  },
  has_whatsapp_phone_number: {
    label: 'Send Notifications via WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'WhatsApp Number',
    add: 'Add Phone Number',
  },
  party_size: {
    label: 'Party size allowed per reservation',
    min_label: 'Min',
    max_label: 'Max',
    to: 'to',
    guests: 'guests',
    helper: 'How small or large a booking can be. A guest can only reserve for a number of people within this range.',
    warning:
      "Google only accepts bookings for 2–16 guests. Bookings outside this range will still work on your storefront, but won't show on Google.",
    warning_min: 'Google recommends a minimum of 2 guests for reservations.',
    warning_max: 'Google recommends a maximum of 16 guests for reservations.',
    min_note: 'Google will not offer reservations for parties smaller than {{count}}.',
  },
  time_slot: {
    label: 'Booking interval',
    helper: 'Guests can book in increments of this many minutes.',
    extra: 'e.g. {{example}}',
  },
  reservation_gap: {
    label: 'Booking cutoff before closing',
    helper: 'The last time a guest can start a booking, counted back from your closing time.',
    helper_link: 'View your reservation hours',
    extra: 'e.g. you close at 22:00, cutoff {{example}} min → last bookable start is {{example}}',
  },
  reservation_notice_period: {
    label: 'Minimum advance notice',
    helper: 'Earliest a guest can book before their arrival time.',
    extra: 'e.g. book by {{example}} for an 18:00 arrival',
  },
  opening_times: {
    label: 'Opening hours',
  },
  total_seats: {
    label: 'Total guest capacity',
    helper:
      'The maximum number of guests (not tables) who can be seated at the same time. Count individual seats — e.g. 5 tables of 4 = 20.',
  },
  capacity_explainer: {
    title: 'How capacity works',
    body: "This is how many guests you can seat at once. Each booking holds its seats for its duration, then frees them for the next guests. The system keeps enough room for everyone booked, so you're never overbooked.",
    body_example:
      "Example: with 20 seats, you can take a 12-guest booking at 19:00 and a 10-guest booking at 21:00, because the first party's seats free up before the next one arrives.",
  },
  note: {
    label: 'Note',
  },
  grace_period: {
    label: 'Grace period',
    helper: 'How long to hold a table after the reservation start time.',
    tooltip:
      "Extra buffer added after a booking's duration before the table is offered again (e.g. to clear and reset the table).",
    extra: 'e.g. holds until {{example}} for an 18:00 booking',
    placeholder: 'Enter grace period',
  },
  information: {
    rules: {
      label: 'Your table will be reserved for:',
      add: 'Add',
    },
  },
  reservation_duration: {
    label: 'Reservation duration',
    helper: 'How long each table is held per booking.',
    tooltip:
      'How long a table is held for each booking. This is used to work out when a table becomes free again for the next guest.',
    extra: 'e.g. 18:00 – {{example}}',
    minutes: '{{ count }} Minutes',
    hour_one: '{{ count }} Hour',
    hour_other: '{{ count }} Hours',
  },
  buttons: {
    save: 'Save',
    activate: 'Activate',
    deactivate: 'Deactivate',
  },
  success_messages: {
    updated: 'Update successful',
    saving_successful: 'Update successful. Please note that Google may take up to 24 hours to reflect the changes.',
  },
  error_messages: {
    invalid_phone_number: 'Invalid Phone Number',
    saving_unsuccessful: 'Error saving changes. Please try again.',
    enter_correct_email: 'Please enter a correct email address.',
  },
};
